var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowestMarks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-groups_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups_5",
    "data-name": "groups \\u2013 5",
    clipPath: "url(#clip-groups_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 255.5,
    cy: 255.5,
    r: 255.5,
    transform: "translate(1 1)",
    fill: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-up",
    "data-name": "Icon awesome-arrow-up",
    d: "M15.319,99.432,3.994,110.757a12.193,12.193,0,0,0,0,17.294l99.124,99.175a12.193,12.193,0,0,0,17.294,0L219.536,128.1a12.193,12.193,0,0,0,0-17.294L208.21,99.483a12.258,12.258,0,0,0-17.5.2L132.2,161.11V14.49A12.214,12.214,0,0,0,119.953,2.246H103.628A12.214,12.214,0,0,0,91.384,14.49V161.11L32.818,99.636a12.169,12.169,0,0,0-17.5-.2Z",
    transform: "translate(144.602 139.753)",
    fill: "#3a3a3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowestMarks);
export default __webpack_public_path__ + "static/media/lowest-marks.06e57ed6.svg";
export { ForwardRef as ReactComponent };